const messageContextTypes = {
  COURSE : 'course',
  GROUP  : 'group'
};

export { messageContextTypes };
